var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9584 3.5H2.04159C1.71942 3.5 1.45825 3.76117 1.45825 4.08333V5.98914C1.45825 6.24365 1.62324 6.46876 1.86593 6.54541L6.82452 8.11119C6.93879 8.1473 7.06147 8.1473 7.1758 8.11119L12.134 6.54541C12.3766 6.46876 12.5416 6.24365 12.5416 5.9892L12.5418 4.08338C12.5418 3.76119 12.2806 3.5 11.9584 3.5Z",
    stroke: "#44546F",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04152 6.70825L2.0415 11.3749C2.0415 12.0193 2.56384 12.5416 3.20817 12.5416H10.7915C11.4358 12.5416 11.9582 12.0193 11.9582 11.3749V6.70825",
    stroke: "#44546F",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04159 3.49992L8.82144 1.95909C8.78043 1.67171 8.53427 1.45825 8.244 1.45825H5.75584C5.46554 1.45825 5.21942 1.67171 5.17837 1.95909L4.95825 3.49992",
    stroke: "#44546F",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_6623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.cf82dcf96503604767d950861d8557e2.svg";
export { ForwardRef as ReactComponent };